(function (Drupal) {
  Drupal.behaviors.externalLinksToNewWindow = {
    attach(context) {
      const externalLinks = context.querySelectorAll(`a[href*="//"]:not([href*="${window.location.origin}"])`);
      [...externalLinks].forEach(item => item.setAttribute('target', '_blank'));
    },
  };
}(Drupal));
